<template>
  <div class="detail-pop">
    <div class="close-con">
      <span class="star-wrapper" v-if="selectedReviewer.pilot_network === PILOT_NETWORK.MAAC_CLUB">
        <span class="star material-icons">
          star
        </span>
        <md-tooltip md-direction="top" style="text-align: left;">
          <div style="color: #000; font-weight: 500;">
            {{ $t("Preferred flight review site:") }}
          </div>
          <div>
            •⁠
            {{
    $t(
      "Includes a free 3-month MAAC introductory membership paid for by us."
    )
  }}
          </div>
          <div>
            •⁠
            {{
      $t(
        "Once a member, the flight review is covered by insurance."
      )
    }}
          </div>
        </md-tooltip>
        <span>{{ selectedReviewer.club_name }}</span>
      </span>
      <span v-else></span>
      <span class="pointer material-icons" @click="closeDetailPop">
        close
      </span>
    </div>
    <div v-if="selectedReviewer.pilot_network === PILOT_NETWORK.MAAC_CLUB &&
    $route.path === '/flight-review/map'
    ">
      <div style="margin: 8px 0;">
        {{
    selectedReviewer.review_street
      ? selectedReviewer.review_street
      : `${selectedReviewer.latitude &&
      selectedReviewer.latitude.toFixed(
        6
      )}, ${selectedReviewer.longitude &&
      selectedReviewer.longitude.toFixed(6)}`
  }}, {{ selectedReviewer.review_city }},
        {{ selectedReviewer.review_province }}
      </div>
      <div v-if="selectedReviewer.review_street_desc" class="sub-title" style="margin: 8px 0;">
        {{ selectedReviewer.review_street_desc }}
      </div>
      <md-button v-if="$route.path === '/flight-review/map'" class="md-primary" @click="bookReview(selectedReviewer)">{{
    $t("Book") }}</md-button>
    </div>
    <div v-else-if="selectedReviewer.pilot_network === PILOT_NETWORK.MAAC_CLUB">
      <div style="margin: 8px 0;">
        {{
        selectedReviewer.review_street
          ? selectedReviewer.review_street
          : `${selectedReviewer.latitude &&
          selectedReviewer.latitude.toFixed(
            6
          )}, ${selectedReviewer.longitude &&
          selectedReviewer.longitude.toFixed(6)}`
      }}, {{ selectedReviewer.review_city }},
        {{ selectedReviewer.review_province }}
      </div>
      <div v-if="selectedReviewer.review_street_desc" class="sub-title" style="margin: 8px 0;">
        {{ selectedReviewer.review_street_desc }}
      </div>
      <div style="text-align: right;">
        <md-checkbox class="maac-reviewer" v-model="isMAACMemberCheckbox" @change="isMAACMemberDetailFilter">{{ $t("MAAC Club Designated Flight Reviewer") }}</md-checkbox>
      </div>
      <div v-if="this.clubReviewListLoading">loading...</div>
      <div v-if="clubReviewList.length === 0 && !this.clubReviewListLoading">
        {{ $t("No flight reviewer yet") }}
      </div>
      <collapse :collapse="clubReviewList" :getCurrentActive="getClubInterviewerActive">
        <template v-for="(item, s_index) in clubReviewList">
          <template :slot="'md-collapse-pane-' + (s_index + 1) + 'title'">
            <div class="star-wrapper">
              <span>
                <img v-if="item.pilot_network === PILOT_NETWORK.MAAC_REVIEWER" class="maac-reviewer"
                  src="/img/plane_red.png" alt="" />
                {{ item.title }}
                <md-tooltip v-if="item.pilot_network === PILOT_NETWORK.MAAC_REVIEWER" md-direction="top"
                  style="text-align: left;">
                  <div>
                    {{ $t("MAAC Club Designated Flight Reviewer") }}
                  </div>
                </md-tooltip>
              </span>
            </div>
          </template>
          <template :slot="'md-collapse-pane-' + (s_index + 1)">
            <ReviewerPackage :onChange="reviewerPackageChange" :packageList="packageList"
              :disabled="false" />
            <div style="text-align: right; padding-right: 16px;">
              <md-button class="md-primary" :disabled="booking.reviewerId === item.reviewer_id"
                @click="clubReviewSelect(item)">{{ booking.reviewerId === item.reviewer_id ? $t("selected") : $t("Book") }}
              </md-button>
            </div>
          </template>
        </template>
      </collapse>
    </div>
    <div v-else>
      <div class="reviewer-block-title" v-if="selectedReviewer.pilot_network ===
    PILOT_NETWORK.PUBLIC_SERVICE_REVIEWER
    ">
        <img src="/img/police.png" alt="" />
        {{ $t("Public Service Designated Flight Reviewer") }}
      </div>
      <div class="reviewer-block-title" v-if="selectedReviewer.pilot_network === PILOT_NETWORK.REVIEWER">
        <img src="/img/rpa-blue.png" alt="" />
        {{ $t("Independent Flight Reviewer") }}
      </div>
      <div>
        {{
    selectedReviewer.review_street
      ? selectedReviewer.review_street
      : `${selectedReviewer.latitude &&
      selectedReviewer.latitude.toFixed(
        6
      )}, ${selectedReviewer.longitude &&
      selectedReviewer.longitude.toFixed(6)}`
  }}, {{ selectedReviewer.review_city }},
        {{ selectedReviewer.review_province }}
      </div>
      <div v-if="selectedReviewer.review_street_desc" class="sub-title" style="margin: 8px 0;">
        {{ selectedReviewer.review_street_desc }}
      </div>
      <div style="margin: 8px 0;">
        <ReviewerPackage :onChange="reviewerPackageChange" :packageList="packageList" :disabled="$route.path === '/flight-review/map'"/>
      </div>
      <div style="text-align: right; padding-right: 16px;">
        <md-button v-if="$route.path === '/flight-review/map'" class="md-primary" @click="bookReview(selectedReviewer)">{{
        $t("Book") }}</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { PILOT_NETWORK } from "@/const";
import {
  findClubReviewers,
  getPackageById
} from "@/services/flightReview.service.js";
import swal from "sweetalert2";
import Collapse from "@/components/CollapseBrief.vue";
import ReviewerPackage from "./ReviewerPackage.vue";
import { mapFields } from "vuex-map-fields";
export default {
  components: {
    Collapse,
    ReviewerPackage
  },
  props: {
    closeDetailPop: {
      type: Function,
      default: () => { }
    },
    selectedReviewer: {
      type: Object,
      default: { }
    },
    isMAACMemberCheckboxDefault: {
      type: Boolean,
      default: false
    },
    isMAACMember: {
      type: Boolean,
      default: false
    },
    bookingCbfn: {
      type: Function,
      default: () => { }
    },
  },
  data() {
    return {
      clubReviewList: [],
      clubReviewListLoading: false,
      PILOT_NETWORK,
      isMAACMemberCheckbox: this.isMAACMemberCheckboxDefault,
      packageList: []
    };
  },
  computed: {
    ...mapFields("auth", ["loggedOn"]),
    ...mapFields("flightReview", ["booking"])
  },
  async mounted() {
    if (this.selectedReviewer.pilot_network !== PILOT_NETWORK.MAAC_CLUB) {
      this.getReviewPackage(this.selectedReviewer.reviewer_id)
    }
    if (
      this.selectedReviewer.pilot_network === PILOT_NETWORK.MAAC_CLUB &&
      this.$route.path !== "/flight-review/map"
    ) {
      this.getClubReviewersByClubId(this.selectedReviewer.reviewer_id);
    } else {
      if (this.bookingCbfn) this.bookingCbfn(this.selectedReviewer, this.isMAACMember);
    }
  },
  methods: {
    bookReview(reviewerInfo) {
      if (this.loggedOn) {
        sessionStorage.setItem("reviewerInfo", JSON.stringify(reviewerInfo));
        this.$router.push("/flight-review/booking");
        return;
      }
      swal
        .fire({
          text: this.$t("Login required for Booking Flight Review."),
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            sessionStorage.setItem(
              "reviewerInfo",
              JSON.stringify(reviewerInfo)
            );
            this.$router.push({
              path: "/login",
              query: { loginSuccessTargetPage: "/flight-review/booking" }
            });
          }
        });
    },
    async getReviewPackage(reviewerId) {
      const list = await getPackageById(reviewerId)
      this.packageList = list
      // everytime get package reset selectedPackageKeys and packageList
      this.$store.commit("flightReview/updateBooking", {
        selectedPackageKeys: [],
        packageList: list
      });
    },
    async getClubReviewersByClubId(clubId) {
      if(!clubId) return

      try {
        this.clubReviewListLoading = true;
        const data = await findClubReviewers(clubId, this.isMAACMemberCheckbox);
        this.clubReviewListLoading = false;
        data.map(item => {
          item.title = `${item.firstname} ${item.lastname &&
            item.lastname.substring(0, 1).toUpperCase()}`;
          return item;
        });
        this.clubReviewList = data;
      } catch (err) {
        this.clubReviewListLoading = false;
      }
    },
    clubReviewSelect(item) {
      this.$store.commit("flightReview/updateBooking", {
        reviewerId: item.reviewer_id,
        addressId: item._id.$oid,
      });
      this.$notify({
        message: this.$t("Flight reviewer selected"),
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success",
        timeout: 3000
      });
    },
    isMAACMemberDetailFilter(val) {
      this.isMAACMemberCheckbox = val;
      this.getClubReviewersByClubId(this.selectedReviewer.reviewer_id);
    },
    reviewerPackageChange(val) {
      this.$store.commit("flightReview/updateBooking", {
        selectedPackageKeys: [...val]
      });
    },
    getClubInterviewerActive(idx) {
      const activeClubReviewer = this.clubReviewList[idx - 1]
      this.getReviewPackage(activeClubReviewer.reviewer_id)
    }
  },
  watch: {
    isMAACMemberCheckboxDefault(val) {
      if (val !== this.isMAACMemberCheckbox) {
        this.isMAACMemberDetailFilter(val)
      }
    }
  }
};
</script>